<ngx-spinner type="square-jelly-box">

    <!-- <h4 style="color: #fff;font-family: BYekan;font-size: 23px;">... لطفا منتظر بمانید </h4> -->
    
</ngx-spinner>

<router-outlet></router-outlet>